(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var charts = document.querySelectorAll('.chart-bar-horizontal');
  if (!charts.length) return;

  charts.forEach(function (chart) {
    var bars = chart.querySelectorAll('[data-bar-index]');
    bars.forEach(function (bar) {
      var fill = bar.querySelector('.chart-bar-horizontal__fill');
      var counter = bar.querySelector('[data-bar-counter]');
      var direction = bar.dataset.barDirection;
      var startVal = parseInt(bar.dataset.barStart, 10) || 0;
      var endVal = parseInt(bar.dataset.barEnd, 10) || 0;

      var initialWidth = direction === 'backward' ? endVal : startVal;
      if (fill) fill.style.width = initialWidth + '%';
      if (counter) counter.textContent = initialWidth + '%';
    });
  });

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var chart = entry.target;
      if (chart.dataset.chartPlayed) return;
      chart.dataset.chartPlayed = '1';

      var bars = chart.querySelectorAll('[data-bar-index]');
      var duration = parseInt(chart.dataset.chartDuration, 10) || 2000;
      var delay = parseInt(chart.dataset.chartDelay, 10) || 0;
      var stagger = parseInt(chart.dataset.chartStagger, 10) || 100;

      bars.forEach(function (bar, i) {
        var fill = bar.querySelector('.chart-bar-horizontal__fill');
        var counter = bar.querySelector('[data-bar-counter]');
        var direction = bar.dataset.barDirection;
        var startVal = parseInt(bar.dataset.barStart, 10) || 0;
        var endVal = parseInt(bar.dataset.barEnd, 10) || 0;

        var fromVal, toVal;
        if (direction === 'backward') {
          fromVal = endVal;
          toVal = startVal;
        } else {
          fromVal = startVal;
          toVal = endVal;
        }

        var barDelay = delay + (i * stagger);

        function animateBar() {
          var animStart = performance.now();

          function tick(now) {
            var t = Math.min(1, (now - animStart) / duration);
            var eased = 1 - Math.pow(1 - t, 3);

            var currentVal = fromVal + (toVal - fromVal) * eased;
            if (fill) fill.style.width = currentVal + '%';
            if (counter) counter.textContent = Math.round(currentVal) + '%';

            if (t < 1) {
              requestAnimationFrame(tick);
            } else {
              if (fill) fill.style.width = toVal + '%';
              if (counter) counter.textContent = toVal + '%';
            }
          }

          requestAnimationFrame(tick);
        }

        if (barDelay > 0) {
          setTimeout(animateBar, barDelay);
        } else {
          animateBar();
        }
      });

      obs.unobserve(chart);
    });
  }, { threshold: 0.15 });

  charts.forEach(function (el) { obs.observe(el); });
})();
